import type { AuthType } from '@particle-network/auth';
import type { Chain, Wallet } from '@rainbow-me/rainbowkit';
import { titleCase } from '../utils/titleCase';
import { ParticleConnector } from './particleConnector';

export interface ParticleWalletOptions {
    chains: Chain[];
    authType?: Exclude<AuthType, 'jwt'>;
}

export const particleWallet = ({ chains, authType }: ParticleWalletOptions): Wallet => ({
    id: authType ? `particle${authType}` : 'particle',
    name: authType ? titleCase(authType) : 'Particle',
    iconUrl: async () => {
        const icons = await import('./icons');
        return authType ? icons[authType] : icons.particle;
    },
    iconBackground: authType ? '#ffffff' : '#d61ace',
    installed: typeof window !== 'undefined',
    createConnector: () => {
        const connector = new ParticleConnector({
            chains: chains,
            options: {
                auth: typeof window === 'undefined' ? undefined : window.particle?.auth,
                authType: authType,
            },
        });

        return {
            connector,
        };
    },
});
